import { FC, createElement } from 'react';
import cn from 'classnames';

import { generateValidationParams } from '@/utils/generateValidationParams';

import { InputProps } from './Input.props';

export const FeedbackInput: FC<InputProps> = ({
  className,
  register,
  required,
  type = 'text',
  name = '',
  locale = 'UA',
  ...rest
}: InputProps) => {
  const inputProps = {
    ...register(
      name,
      generateValidationParams({ type, name, required, locale }),
    ),
    noValidate: type == 'email' ? true : false,
    type,
    className: cn(
      'block w-full rounded-lg border border-primaryLight dark:bg-black bg-gray-50 p-2.5 text-sm text-primaryMiddle focus:border-accentMain focus:ring-accentMain dark:text-white dark:placeholder-primaryLight dark:focus:border-accentMain dark:focus:ring-accentMain',
      className,
      {
        'resize-none': type == 'textarea',
      },
    ),
    ...rest,
    ...(type == 'textarea' && { rows: 3, maxLength: 300 }),
  };

  return (
    <>{createElement(type == 'textarea' ? 'textarea' : 'input', inputProps)}</>
  );
};
